"use client";

import Link, { LinkProps } from "next/link";
import { FC, Suspense, useState } from "react";

import { WithChildren } from "apps/website/types";

import { QuerySetter } from "./QuerySetter";

export const LinkWithQuery: FC<LinkProps & WithChildren> = (props) => {
  const [ href, setHref ] = useState<string>(props.href as string);

  return (
    <>
      <Link {...props} href={href} />
      <Suspense>
        <QuerySetter href={props.href as string} onUpdateHref={(newHref) => setHref(newHref)} />
      </Suspense>
    </>
  );
};
